import { render, staticRenderFns } from "./RdDetails.vue?vue&type=template&id=75381859&scoped=true&"
import script from "./RdDetails.vue?vue&type=script&lang=js&"
export * from "./RdDetails.vue?vue&type=script&lang=js&"
import style0 from "./RdDetails.vue?vue&type=style&index=0&id=75381859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75381859",
  null
  
)

export default component.exports